import {CommonModule} from '@angular/common';
import {Component} from '@angular/core';
import {ButtonModule} from 'primeng/button';
import {ConfirmDialog} from 'primeng/confirmdialog';

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [CommonModule, ConfirmDialog, ButtonModule],
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss',
})
export class ConfirmDialogComponent {
  getIconClass(message: unknown): string {
    const icon = (message as {icon?: string} | null)?.icon;
    return icon && icon.trim().length > 0 ? icon : 'pi pi-exclamation-triangle';
  }

  getAcceptLabel(message: unknown): string {
    return (message as {acceptLabel?: string} | null)?.acceptLabel || 'Confirm';
  }

  getRejectLabel(message: unknown): string {
    return (message as {rejectLabel?: string} | null)?.rejectLabel || 'Cancel';
  }
}
